import React from 'react';

export interface BaseImageProps {
    alt: string; // making 'alt' property required because it is mandatory in HTML4
    src: string;
}

type Props = BaseImageProps & React.ImgHTMLAttributes<HTMLImageElement>;

const Image: React.FC<Props> = (props) => <img {...props} />;

export { Image };
